import Service from '../Service';
import UserAccount from '../UserAccount';
import LogicBaseSearchApi from '../server/LogicBaseSearchApi';

/** Vector search — stores API payload only (`content` + `collections` display-ready). */
class LogicBaseSearchCache extends Service {
  api = LogicBaseSearchApi;

  initialize() {
    this.resultsByQuery = {};
    this.pendingQueryKeys = new Set();
  }

  query(_query) {
    const merged = { ..._query };
    const key = JSON.stringify(
      Object.keys(merged).sort().reduce((acc, k) => (acc[k] = merged[k], acc), {}),
    );
    if (Object.prototype.hasOwnProperty.call(this.resultsByQuery, key)) {
      return this.resultsByQuery[key];
    }
    if (this.pendingQueryKeys.has(key)) {
      return null;
    }
    this.pendingQueryKeys.add(key);

    this.api.query(merged).then((body) => {
      this.pendingQueryKeys.delete(key);
      if (!body) {
        this.resultsByQuery[key] = { content: [], collections: [] };
        this.emitStateUpdate();
        return;
      }
      this.resultsByQuery[key] = {
        content: Array.isArray(body.content) ? body.content : [],
        collections: Array.isArray(body.collections) ? body.collections : [],
      };
      this.emitStateUpdate();
    });
    return null;
  }
}

const singleton = new LogicBaseSearchCache();
singleton.initialize();
UserAccount.onStateUpdate((_, state) => {
  if (state) {
    singleton.initialize();
  }
});
export default singleton;
